module.exports = __webpack_public_path__ + "img/map-sites.40dafc22.png";